<template>
    <div class="languages">
      <button class="languages__btn">{{$i18n.locale}}</button>
      <div class="languages__content">
        <button class="languages__content__lang"
             v-for="item in $i18n.availableLocales.filter(i=>i!==$i18n.locale)" :key="item" @click="$i18n.locale=item">
          {{ item }}
        </button>
      </div>
    </div>
</template>

<script>
    export default {
        name: "LanguageSelector"
    }
</script>